import { Record } from 'immutable';
import { CLIENT_OUTDATED, REQUIRE_INTERACTIVE_RELOAD } from 'app/remote/client/constants';

const ClientState = Record({
  clientOutdated: false,
  interactiveReloadRequired: false,
});

const INITIAL_STATE = ClientState();

export const clientReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;

  switch (type) {
    case CLIENT_OUTDATED:
      return state.set('clientOutdated', true);
    case REQUIRE_INTERACTIVE_RELOAD:
      return state.set('interactiveReloadRequired', true);
    default:
      return state;
  }
};
